import axios from "axios";
import { Base_URL } from "../url";

export const saveRequestTrip = async (tripData) => {
  console.log(tripData);
  try {
    const response = await axios.post(`${Base_URL}/RequestedTrips/RequestedTrip`, tripData, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to save trip request";
  }
};